// idea from https://github.com/a8m/angular-filter
import { Pipe } from '@angular/core';
import { isString, isUndefined } from '../utils/utils';
var StripTagsPipe = (function () {
    function StripTagsPipe() {
    }
    StripTagsPipe.prototype.transform = function (input) {
        if (!isString(input) || isUndefined(input))
            return input;
        return input.replace(/<\S[^><]*>/g, '');
    };
    return StripTagsPipe;
}());
export { StripTagsPipe };
StripTagsPipe.decorators = [
    { type: Pipe, args: [{
                name: 'stripTags'
            },] },
];
/** @nocollapse */
StripTagsPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=strip-tags.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/string/strip-tags.pipe.js
// module id = 290
// module chunks = 103